import { type ComputedRef, computed } from 'vue';

import useAuth from '@/composables/useAuth';
import {
  TEMP_ADD_OPEN_DATA_PARTNER,
  TEMP_DEPRECATED_MOP,
} from '@/constants/feature_flags';
import { useFeatureFlagStore } from '@/stores';
import {
  OPEN_DATA_PARTNER_AB_TEST_THRESHOLD,
  isOrgInAbTestGroup,
} from '@/utils/abTestGate';

export default function useHasOpenDataPartnerAccess(): ComputedRef<boolean> {
  const { hasFeatureFlag } = useFeatureFlagStore();
  const { currentOrg } = useAuth();

  return computed(() => {
    // Orgs whose MOPs are deprecated are asked to replace them with Open Data
    // Partners, so they get the ODP experience regardless of the A/B group.
    if (hasFeatureFlag(TEMP_DEPRECATED_MOP)) return true;
    if (!hasFeatureFlag(TEMP_ADD_OPEN_DATA_PARTNER)) return false;
    return isOrgInAbTestGroup(
      currentOrg.value.id,
      OPEN_DATA_PARTNER_AB_TEST_THRESHOLD,
    );
  });
}
